<template>
  <div>
    <QueryFrame
      add-text=""
      :count="count"
      :current="page"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>年份:</label>
            <lk-select
              class="item"
              v-model="query.year"
              filterable>
              <lk-option v-for="item in years" :key="item" :value="item">{{item}}年</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>门店名称:</label>
            <lk-select
              class="item"
              v-model="query.storeIdList"
              clearable
              filterable>
              <lk-option v-for="item in storeList" :key="item.id" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
          </div>
          <div class="queryItem">
            <label>来源类型:</label>
            <lk-select
              class="item"
              v-model="query.epSourceType"
              clearable>
              <lk-option v-for="item in epSourceList" :key="item.id" :value="item.id">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>ID类型:</label>
            <lk-select
              class="item"
              v-model="query.epCreatorType"
              clearable
              filterable>
              <lk-option v-for="item in epCreatorTypeList" :key="item.value" :value="item.value">{{item.label}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>来源姓名:</label>
            <lk-select
              class="item"
              v-model="query.epCreatorId"
              clearable
              filterable>
              <lk-option v-for="item in epCreatorList" :key="item.id" :value="item.id">{{item.id}}-{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch(false, getSummaryInfo)">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="mb16">
          <lk-tabs type="card" v-model="type" @on-click="handleStatisticsType">
            <lk-tab-pane label="年统计" name="1"></lk-tab-pane>
            <lk-tab-pane label="月统计" name="2"></lk-tab-pane>
          </lk-tabs>
          <div class="summary">
            <div class="summary-item" v-show="type === '2'">
              <lk-select
                @on-change="handleSearch(false, getSummaryInfo)"
                v-model="query.month"
                style="width: 80px;">
                <lk-option v-for="item in 12" :value="item" :key="item">{{item}}月</lk-option>
              </lk-select>
            </div>
            <div class="summary-item">门店数：<span class="summary-item-value">{{summaryInfo.storeNum || 0 }}</span></div>
            <div class="summary-item">
              <DownloadButton class="" @on-click="handleDownload" v-if="type === '1' && handlePermission('statisticsViewYearExcel')"></DownloadButton>
              <DownloadButton class="" @on-click="handleDownload" v-if="type === '2' && handlePermission('statisticsViewMonthExcel')"></DownloadButton>
            </div>
          </div>
          <div class="summary">
            <div class="summary-item">当{{getTypeName}}销量(万元)/上{{getTypeName}}销量(万元)：<span class="summary-item-value">{{summaryInfo.amountStr || 0 }} / {{summaryInfo.lastAmountStr || 0 }}</span></div>
            <div class="summary-item">DTP当{{getTypeName}}销量(万元)/DTP上{{getTypeName}}销量(万元)：<span class="summary-item-value">{{summaryInfo.dtpAmountStr || 0 }} / {{summaryInfo.dtpLastAmountStr || 0 }}</span></div>
          </div>
        </div>
        <barChart id="chart-bar" :xData="xData" :yData="yData" :xRotate="xData.length > 20 ? 30 : 15" height="280px"></barChart>
        <lk-table border :columns="yearColumns" :data="tableData" v-show="type === '1'"></lk-table>
        <lk-table border :columns="monthColumns" :data="tableData" v-show="type === '2'"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import reportService from '../../services/report';
import systemService from '../../services/system';
import saleService from '../../services/sale';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import barChart from '../../components/charts/Bar.vue';
import DownloadButton from '../../components/download/DownloadButton';

export default {
  name: 'statisticsView',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    barChart,
    DownloadButton,
  },
  data() {
    return {
      query: {
        year: new Date().getFullYear(),
        month: 1,
        storeIdList: [],
        nameMix: '',
        epSourceType: '',
        epCreatorType: '',
        epCreatorId: '',
      },
      xData: [],
      yData: [],
      epSourceList: [],
      epCreatorTypeList: [
        {
          label: '医生',
          value: '1',
        },
        {
          label: '药师',
          value: '2',
        },
      ],
      epCreatorList: [],
      storeList: [],
      years: [],
      type: '1', // 统计类型 '1'年统计 '2'月统计
      // options: {
      //   disabledDate(date) {
      //     return date.valueOf() < new Date('2016-12-31').getTime();
      //   },
      // },
      summaryInfo: {},
      yearColumns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        {
          title: '门店编码',
          key: 'storeCode',
          minWidth: 116,
        },
        {
          title: '门店名称',
          key: 'storeName',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => {
            const vm = this;
            return this.handlePermission('statisticsViewDetail') ? h('a', {
              on: {
                click() {
                  vm.handleToViewDetail(row);
                },
              },
            }, row.storeName) : h('span', row.storeName);
          },
        },
        {
          title: '毛利率(%)',
          key: 'profitRateStr',
          minWidth: 116,
        },
        {
          title: '当年销量(万元)',
          key: 'amountOfTheYearStr',
          minWidth: 116,
        },
        {
          title: '上年销量(万元)',
          key: 'amountOfTheLastYearStr',
          minWidth: 116,
        },
        {
          title: '环比(%)',
          key: 'chainRatioStr',
          minWidth: 116,
          render: (h, { row }) => {
            const chainRatio = parseFloat(row.chainRatioStr);
            const flag = chainRatio < 0;
            return h('div', {
              class: {
                red: flag, // 负数变红
              },
            }, [
              h('span', row.chainRatioStr),
              chainRatio !== 0 ? h('lk-icon', {
                props: {
                  type: flag ? 'md-arrow-round-down' : 'md-arrow-round-up',
                  size: 14,
                },
              }) : null,
            ]);
          },
        },
        {
          title: 'DTP毛利率',
          key: 'dtpProfitRateStr',
          minWidth: 116,
        },
        {
          title: 'DTP当年销量(万元)',
          key: 'dtpAmountOfTheYearStr',
          minWidth: 116,
        },
        {
          title: 'DTP上年销量(万元)',
          key: 'dtpAmountOfTheLastYearStr',
          minWidth: 116,
        },
        {
          title: 'DTP环比(%)',
          key: 'dtpChainRatioStr',
          minWidth: 116,
          render: (h, { row }) => {
            const chainRatio = parseFloat(row.dtpChainRatioStr);
            const flag = chainRatio < 0;
            return h('div', {
              class: {
                red: flag, // 负数变红
              },
            }, [
              h('span', row.dtpChainRatioStr),
              chainRatio !== 0 ? h('lk-icon', {
                props: {
                  type: flag ? 'md-arrow-round-down' : 'md-arrow-round-up',
                  size: 14,
                },
              }) : null,
            ]);
          },
        },
      ],
      monthColumns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        {
          title: '门店编码',
          key: 'storeCode',
          minWidth: 116,
        },
        {
          title: '门店名称',
          key: 'storeName',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => {
            const vm = this;
            return this.handlePermission('statisticsViewDetail') ? h('a', {
              on: {
                click() {
                  vm.handleToViewDetail(row, true);
                },
              },
            }, row.storeName) : h('span', row.storeName);
          },
        },
        {
          title: '毛利率(%)',
          key: 'profitRateStr',
          minWidth: 116,
        },
        {
          title: '当月销量(万元)',
          key: 'amountOfTheMonthStr',
          minWidth: 116,
        },
        {
          title: '上月销量(万元)',
          key: 'amountOfTheLastMonthStr',
          minWidth: 116,
        },
        {
          title: '环比(%)',
          key: 'chainRatioStr',
          minWidth: 116,
          render: (h, { row }) => {
            const chainRatio = parseFloat(row.chainRatioStr);
            const flag = chainRatio < 0;
            return h('div', {
              class: {
                red: flag, // 负数变红
              },
            }, [
              h('span', row.chainRatioStr),
              chainRatio !== 0 ? h('lk-icon', {
                props: {
                  type: flag ? 'md-arrow-round-down' : 'md-arrow-round-up',
                  size: 14,
                },
              }) : null,
            ]);
          },
        },
        {
          title: '同比(%)',
          key: 'periodRatioStr',
          minWidth: 116,
          render: (h, { row }) => {
            const periodRatio = parseFloat(row.periodRatioStr);
            const flag = periodRatio < 0;
            return h('div', {
              class: {
                red: flag, // 负数变红
              },
            }, [
              h('span', row.periodRatioStr),
              periodRatio !== 0 ? h('lk-icon', {
                props: {
                  type: flag ? 'md-arrow-round-down' : 'md-arrow-round-up',
                  size: 14,
                },
              }) : null,
            ]);
          },
        },
        {
          title: 'DTP毛利率',
          key: 'dtpProfitRateStr',
          minWidth: 116,
        },
        {
          title: 'DTP当月销量(万元)',
          key: 'dtpAmountOfTheMonthStr',
          minWidth: 116,
        },
        {
          title: 'DTP上月销量(万元)',
          key: 'dtpAmountOfTheLastMonthStr',
          minWidth: 116,
        },
        {
          title: 'DTP环比(%)',
          key: 'dtpChainRatioStr',
          minWidth: 116,
          render: (h, { row }) => {
            const chainRatio = parseFloat(row.dtpChainRatioStr);
            const flag = chainRatio < 0;
            return h('div', {
              class: {
                red: flag, // 负数变红
              },
            }, [
              h('span', row.dtpChainRatioStr),
              chainRatio !== 0 ? h('lk-icon', {
                props: {
                  type: flag ? 'md-arrow-round-down' : 'md-arrow-round-up',
                  size: 14,
                },
              }) : null,
            ]);
          },
        },
        {
          title: 'DTP同比(%)',
          key: 'dtpPeriodRatioStr',
          minWidth: 116,
          render: (h, { row }) => {
            const chainRatio = parseFloat(row.dtpPeriodRatioStr);
            const flag = chainRatio < 0;
            return h('div', {
              class: {
                red: flag, // 负数变红
              },
            }, [
              h('span', row.dtpPeriodRatioStr),
              chainRatio !== 0 ? h('lk-icon', {
                props: {
                  type: flag ? 'md-arrow-round-down' : 'md-arrow-round-up',
                  size: 14,
                },
              }) : null,
            ]);
          },
        },
      ],
      tableData: [],
    };
  },
  computed: {
    getTypeName() {
      return this.type === '1' ? '年' : '月';
    },
  },
  methods: {
    handleReset() {
      this.query = {
        year: new Date().getFullYear(),
        month: 1,
        storeIdList: [],
        nameMix: '',
        epSourceType: '',
        epCreatorType: '',
        epCreatorId: '',
      };
      if (this.type === '2') {
        this.query.month = 1;
      }
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;

      const finalFn = this.type === '1' ? reportService.getStatisticsYearList : reportService.getStatisticsMonthList;
      finalFn(this.params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.formatChartData(list);
          this.count = count;
          this.tableData = list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    formatChartData(list) {
      // const chartData = {};
      const chartData = {
        currentAmount: [], // 当年|月销售
        lastAmount: [], // 上年|月销售
        dtpCurrentAmount: [], // DTP当年|月销售
        dtpLastAmount: [], // DTP上年|月销售
      };
      const storeNameList = [];
      list.forEach((item) => {
        storeNameList.push(item.shortName);
        if (this.type === '1') { // 年维度
          chartData.currentAmount.push(this.getScale(item.amountOfTheYear) || 0);
          chartData.lastAmount.push(this.getScale(item.amountOfTheLastYear) || 0);
          chartData.dtpCurrentAmount.push(this.getScale(item.dtpAmountOfTheYear) || 0);
          chartData.dtpLastAmount.push(this.getScale(item.dtpAmountOfTheLastYear) || 0);
        } else { // 月维度
          chartData.currentAmount.push(this.getScale(item.amountOfTheMonth) || 0);
          chartData.lastAmount.push(this.getScale(item.amountOfTheLastMonth) || 0);
          chartData.dtpCurrentAmount.push(this.getScale(item.dtpAmountOfTheMonth) || 0);
          chartData.dtpLastAmount.push(this.getScale(item.dtpAmountOfTheLastMonth) || 0);
        }
      });
      this.yData = [
        {
          name: `当${this.getTypeName}销量`,
          value: chartData.currentAmount,
        },
        {
          name: `上${this.getTypeName}销量`,
          value: chartData.lastAmount,
        },
        {
          name: `DTP当${this.getTypeName}销量`,
          value: chartData.dtpCurrentAmount,
        },
        {
          name: `DTP上${this.getTypeName}销量`,
          value: chartData.dtpLastAmount,
        },
      ];
      this.xData = storeNameList;
    },
    getScale(value, iScale = 10000) {
      return utils.toFixed2(value / iScale, 4, 0);
    },
    getSummaryInfo() {
      const finalFn = this.type === '1' ? reportService.getStatisticsYearTotal : reportService.getStatisticsMonthTotal;
      finalFn(this.params).then((res) => {
        if (res.data.status === 200) {
          this.summaryInfo = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleDownload() {
      const params = utils.deepClone(this.params);
      params.page = 0;
      params.size = 0;
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      const finalFn = this.type === '1' ? reportService.getStatisticsYearExport : reportService.getStatisticsMonthExport;
      finalFn(params).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleStatisticsType() {
      this.handleSearch(true, this.getSummaryInfo);
      // this.getData();
    },
    getStores() {
      systemService.getBelongStores().then((res) => {
        if (res.data.status === 200) {
          this.storeList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getSourceType() {
      saleService.getSaleOrderListSourceType().then((res) => {
        if (res.data.status === 200) {
          this.epSourceList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getSaleEPCreator() {
      saleService.getSaleOrderListEPCreator().then((res) => {
        if (res.data.status === 200) {
          this.epCreatorList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // num: 最近几年 flag: true当前年及后边的年 false当前年及已经过去的年
    getNearYears(num, flag = true) {
      const arr = [];
      const oDate = new Date();
      const payload = flag ? 1 : -1;
      for (let i = 0; i < num; i++) {
        if (i === 0) {
          arr.push(oDate.getFullYear());
        } else {
          oDate.setFullYear(oDate.getFullYear() + payload);
          arr.push(oDate.getFullYear());
        }
      }
      return arr;
    },
    handleToViewDetail(row, isMonth) {
      const data = {
        storeId: row.storeId,
        year: this.params.year,
        month: isMonth ? this.params.month : 0,
        nameMix: this.params.nameMix,
        epSourceType: this.params.epSourceType,
        epCreatorType: this.params.epCreatorType,
        epCreatorId: this.params.epCreatorId,
      };

      // 用于展示当前传递到详情页面的检索条件
      const epSourceType = this.epSourceList.filter(item => item.id === this.params.epSourceType).pop() || {}; // 来源类型
      const epCreatorType = this.epCreatorTypeList.filter(item => item.value === this.params.epCreatorType).pop() || {}; // ID类型
      const epCreatorId = this.epCreatorList.filter(item => item.id === this.params.epCreatorId).pop() || {}; // 来源姓名
      const dataStr = {
        storeName: row.storeName,
        nameMix: this.params.nameMix,
        epSourceType: epSourceType.name,
        epCreatorType: epCreatorType.label,
        epCreatorId: epCreatorId.name,
      };
      this.$router.push({
        name: 'statisticsViewDetail',
        params: {
          data: encodeURI(JSON.stringify(data)),
          dataStr: encodeURI(JSON.stringify(dataStr)),
        },
      });
    },
  },
  created() {
    this.years = this.getNearYears(4, false);
    this.getStores();
    this.getSourceType();
    this.getSaleEPCreator();
    this.handleSearch(true, this.getSummaryInfo);
  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
  .summary {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    .summary-title {
      margin-right: 16px;
    }
    .summary-item {
      display: flex;
      margin-right: 16px;
      line-height: 24px;
      .summary-item-value {
        min-width: 20px;
        font-weight: bold;
        font-size: 16px;
      }
    }
  }
</style>
